// import React from 'react';

// const Gallery = () => {
//   const images = [
//     { url: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80', title: 'Luxury Villa Exterior', span: 'col-span-2 row-span-2' },
//     { url: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80', title: 'Modern Architecture', span: 'col-span-1 row-span-1' },
//     { url: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&q=80', title: 'Contemporary Design', span: 'col-span-1 row-span-1' },
//     { url: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=600&q=80', title: 'Premium Interiors', span: 'col-span-1 row-span-2' },
//     { url: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=600&q=80', title: 'Spacious Living', span: 'col-span-1 row-span-1' },
//     { url: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600&q=80', title: 'Elite Residences', span: 'col-span-2 row-span-1' },
//     { url: 'https://images.unsplash.com/photo-1600607687644-aac4c3eac7f4?w=600&q=80', title: 'Construction Quality', span: 'col-span-1 row-span-1' },
//     { url: 'https://images.unsplash.com/photo-1600573472556-e636c2acbf0d?w=600&q=80', title: 'Premium Amenities', span: 'col-span-1 row-span-1' },
//     { url: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=600&q=80', title: 'Elegant Finishes', span: 'col-span-1 row-span-2' },
//     { url: 'https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=800&q=80', title: 'Waterfront Living', span: 'col-span-2 row-span-1' },
//     { url: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600&q=80', title: 'Modern Design', span: 'col-span-1 row-span-1' },
//     { url: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=600&q=80', title: 'Architectural Excellence', span: 'col-span-1 row-span-1' },
//   ];

//   return (
//     <div className="gallery">
//       {/* Premium Hero Section */}
//       <section className="relative min-h-[70vh] flex items-center justify-center bg-[#E8E2D5] overflow-hidden">
//         <div className="container mx-auto px-4 lg:px-8 py-20">
//           <div className="text-center max-w-4xl mx-auto">
//             <div className="inline-block mb-6">
//               <div className="w-20 h-[2px] bg-luxury-accent mx-auto"></div>
//             </div>
//             <h1 className="font-serif text-6xl lg:text-8xl font-bold text-luxury-dark mb-6 tracking-tight">
//               Gallery
//             </h1>
//             <p className="text-xl lg:text-2xl text-luxury-primary/80 font-light leading-relaxed">
//               Showcasing the finest in luxury villa living and architectural excellence
//             </p>
//           </div>
//         </div>

//         {/* Decorative Elements */}
//         <div className="absolute top-20 right-20 w-64 h-64 bg-luxury-accent/5 rounded-full blur-3xl"></div>
//         <div className="absolute bottom-20 left-20 w-96 h-96 bg-luxury-primary/5 rounded-full blur-3xl"></div>
//       </section>

//       {/* Premium Masonry Gallery */}
//       <section className="py-20 lg:py-32 bg-white">
//         <div className="container mx-auto px-4 lg:px-8">
//           <div className="max-w-7xl mx-auto">
//             {/* Grid Layout with varied sizes */}
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 auto-rows-[280px] gap-6">
//               {images.map((image, index) => (
//                 <div
//                   key={index}
//                   className={`group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 ${image.span}`}
//                 >
//                   {/* Image */}
//                   <img
//                     src={image.url}
//                     alt={image.title}
//                     className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
//                   />
                  
//                   {/* Overlay */}
//                   <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
//                     <div className="absolute bottom-0 left-0 right-0 p-6">
//                       <h3 className="font-serif text-xl lg:text-2xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
//                         {image.title}
//                       </h3>
//                       <div className="w-12 h-[2px] bg-luxury-accent mt-3 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
//                     </div>
//                   </div>

//                   {/* Number Badge (Optional premium detail) */}
//                   <div className="absolute top-4 right-4 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
//                     <span className="text-luxury-dark font-semibold text-sm">{String(index + 1).padStart(2, '0')}</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Stats Section - Premium Touch */}
//       <section className="py-20 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-white relative overflow-hidden">
//         <div className="absolute inset-0 opacity-10">
//           <div className="absolute top-0 left-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
//           <div className="absolute bottom-0 right-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
//         </div>

//         <div className="container mx-auto px-4 relative z-10">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto text-center">
//             <div>
//               <div className="font-serif text-5xl lg:text-6xl font-bold mb-3">125+</div>
//               <p className="text-white/80 text-lg uppercase tracking-wider">Villas Completed</p>
//             </div>
//             <div>
//               <div className="font-serif text-5xl lg:text-6xl font-bold mb-3">8.7</div>
//               <p className="text-white/80 text-lg uppercase tracking-wider">Acres of Land</p>
//             </div>
//             <div>
//               <div className="font-serif text-5xl lg:text-6xl font-bold mb-3">100%</div>
//               <p className="text-white/80 text-lg uppercase tracking-wider">Client Satisfaction</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="py-20 lg:py-32 bg-[#E8E2D5]">
//         <div className="container mx-auto px-4 text-center">
//           <div className="max-w-3xl mx-auto">
//             <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
//               Experience Crown Villas
//             </h2>
//             <p className="text-xl text-luxury-primary/80 mb-10 leading-relaxed">
//               Schedule a site visit and witness the luxury firsthand
//             </p>
//             <div className="flex flex-col sm:flex-row gap-6 justify-center">
//               <a
//                 href="/contact"
//                 className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-luxury-dark text-white font-semibold uppercase tracking-wider rounded-sm hover:bg-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
//               >
//                 Schedule Site Visit
//                 <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//                 </svg>
//               </a>
//               <a
//                 href="tel:+919584646464"
//                 className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-white text-luxury-dark font-semibold uppercase tracking-wider rounded-sm border-2 border-luxury-dark hover:bg-luxury-dark hover:text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//                 </svg>
//                 Call Now
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Gallery;


import React, { useRef, useState, useEffect } from 'react';
import  landscape from "../Assets/LANDSCAPE VIEW - (1).jpg";
import landscape2 from "../Assets/LANDSCAPE VIEW - (2).jpg";
import landscape3 from "../Assets/LANDSCAPE VIEW - (3).jpg";
import landscape4 from "../Assets/LANDSCAPE VIEW - (4).jpg";
import landscape5 from "../Assets/LANDSCAPE VIEW - (5).jpg";
import landscape6 from "../Assets/LANDSCAPE VIEW - (6).jpg";
import landscape7 from "../Assets/LANDSCAPE VIEW - (7).jpg";
import landscape8 from "../Assets/LANDSCAPE VIEW - (8).jpg";
import landscape9 from "../Assets/LANDSCAPE VIEW - (9).jpg";
import landscape10 from "../Assets/LANDSCAPE VIEW - (10).jpg";
import landscape11 from "../Assets/LANDSCAPE VIEW - (11).jpg";
import landscape12 from "../Assets/LANDSCAPE VIEW - (12).jpg";
import landscape13 from "../Assets/LANDSCAPE VIEW - (13).jpg";
import landscape14 from "../Assets/LANDSCAPE VIEW - (14).jpg";
import landscape15 from "../Assets/LANDSCAPE VIEW - (15).jpg";
import landscape16 from "../Assets/LANDSCAPE VIEW - (16).jpg";
import landscape17 from "../Assets/LANDSCAPE VIEW - (17).jpg";
import landscape18 from "../Assets/LANDSCAPE VIEW - (18).jpg";
import  landscape19 from "../Assets/LANDSCAPE VIEW - (19).jpg";
import landscape20 from "../Assets/LANDSCAPE VIEW - (20).jpg";

// RevealImage Component with Silver Shimmer Effect

const RevealImage = ({ src, alt, className = "" }) => {
  const wrapperRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setIsRevealed(true);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`relative overflow-hidden ${className}`}>
      <img 
        src={src} 
        alt={alt} 
        className={`w-full h-full object-cover relative z-[1] transition-all duration-[1500ms] ease-out ${
          isRevealed ? 'opacity-100 scale-100 blur-0' : 'opacity-0 scale-110 blur-sm'
        }`}
        style={{ transitionDelay: '800ms' }}
      />
      
      {/* PURE SILVER Gradient Mask */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[2] transition-transform duration-[1500ms] ${
          isRevealed ? 'scale-x-0 origin-right' : 'scale-x-100 origin-left'
        }`}
        style={{ 
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)',
          background: 'linear-gradient(90deg, #C0C0C0 0%, #E8E8E8 25%, #FFFFFF 50%, #E8E8E8 75%, #C0C0C0 100%)'
        }}
      />
      
      {/* Silver Shimmer */}
      <div 
        className={`absolute top-0 left-0 w-full h-full z-[3] transition-all duration-[1500ms] ${
          isRevealed ? 'opacity-0 translate-x-full' : 'opacity-100 translate-x-0'
        }`}
        style={{ 
          transitionDelay: '300ms',
          background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)',
          transitionTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
        }}
      />
    </div>
  );
};

const RevealContent = ({ children, className = "", delay = 0 }) => {
  const contentRef = useRef();
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const el = contentRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setIsRevealed(true);
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, [delay]);
  
  return (
    <div 
      ref={contentRef} 
      className={`transition-all duration-1000 ${
        isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-[60px]'
      } ${className}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
    >
      {children}
    </div>
  );
};

const Gallery = () => {
  const images = [
    { url: landscape17, title: 'Luxury Villa Exterior', span: 'col-span-2 row-span-2' },
    { url: landscape18, title: 'Modern Architecture', span: 'col-span-1 row-span-1' },
    { url: landscape19, title: 'Contemporary Design', span: 'col-span-1 row-span-1' },
    { url: landscape20, title: 'Premium Interiors', span: 'col-span-1 row-span-2' },
    { url: landscape8, title: 'Spacious Living', span: 'col-span-1 row-span-1' },
    { url: landscape9, title: 'Elite Residences', span: 'col-span-2 row-span-1' },
    { url: landscape10, title: 'Construction Quality', span: 'col-span-1 row-span-1' },
    { url: landscape11, title: 'Premium Amenities', span: 'col-span-1 row-span-1' },
    { url: landscape12, title: 'Elegant Finishes', span: 'col-span-1 row-span-2' },
    { url: landscape13, title: 'Waterfront Living', span: 'col-span-2 row-span-1' },
    { url: landscape14, title: 'Modern Design', span: 'col-span-1 row-span-1' },
    { url: landscape15, title: 'Architectural Excellence', span: 'col-span-1 row-span-1' },
  ];

  return (
    <div className="gallery">
      {/* Premium Hero Section */}
      <section className="relative min-h-[70vh] flex items-center justify-center bg-[#E8E2D5] overflow-hidden">
        <div className="container mx-auto px-4 lg:px-8 py-20">
          <RevealContent className="text-center max-w-4xl mx-auto">
            <div className="inline-block mb-6">
              <div className="w-20 h-[2px] bg-luxury-accent mx-auto"></div>
            </div>
            <h1 className="font-serif text-6xl lg:text-8xl font-bold text-luxury-dark mb-6 tracking-tight">
              Gallery
            </h1>
            <p className="text-xl lg:text-2xl text-luxury-primary/80 font-light leading-relaxed">
              Showcasing the finest in luxury villa living and architectural excellence
            </p>
          </RevealContent>
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-20 right-20 w-64 h-64 bg-luxury-accent/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-luxury-primary/5 rounded-full blur-3xl"></div>
      </section>

      {/* Premium Masonry Gallery */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            {/* Grid Layout with varied sizes */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 auto-rows-[280px] gap-6">
              {images.map((image, index) => (
                <RevealContent
                  key={index}
                  delay={100 * (index + 1)}
                  className={`group relative rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 ${image.span}`}
                >
                  <div className="relative w-full h-full overflow-hidden rounded-sm">
                    {/* Image with Reveal Effect */}
                    <RevealImage
                      src={image.url}
                      alt={image.title}
                      className="w-full h-full"
                    />
                    
                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10">
                      <div className="absolute bottom-0 left-0 right-0 p-6">
                        <h3 className="font-serif text-xl lg:text-2xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                          {image.title}
                        </h3>
                        <div className="w-12 h-[2px] bg-luxury-accent mt-3 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                      </div>
                    </div>

                    {/* Number Badge */}
                    <div className="absolute top-4 right-4 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10">
                      <span className="text-luxury-dark font-semibold text-sm">{String(index + 1).padStart(2, '0')}</span>
                    </div>
                  </div>
                </RevealContent>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section - Premium Touch */}
      <section className="py-20 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto text-center">
            <RevealContent delay={100}>
              <div className="font-serif text-5xl lg:text-6xl font-bold mb-3">130</div>
              <p className="text-white/80 text-lg uppercase tracking-wider">Villas Completed</p>
            </RevealContent>
            <RevealContent delay={200}>
              <div className="font-serif text-5xl lg:text-6xl font-bold mb-3">9</div>
              <p className="text-white/80 text-lg uppercase tracking-wider">Acres of Land</p>
            </RevealContent>
            <RevealContent delay={300}>
              <div className="font-serif text-5xl lg:text-6xl font-bold mb-3">100%</div>
              <p className="text-white/80 text-lg uppercase tracking-wider">Customer Satisfaction</p>
            </RevealContent>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 lg:py-32 bg-[#E8E2D5]">
        <div className="container mx-auto px-4 text-center">
          <RevealContent className="max-w-3xl mx-auto">
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
              Experience Crown Villas
            </h2>
            <p className="text-xl text-luxury-primary/80 mb-10 leading-relaxed">
              Schedule a site visit and witness the luxury firsthand
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <a
                href="/contact"
                className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-luxury-dark text-white font-semibold uppercase tracking-wider rounded-sm hover:bg-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                Schedule Site Visit
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </a>
              <a
                href="tel:+919584646464"
                className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-white text-luxury-dark font-semibold uppercase tracking-wider rounded-sm border-2 border-luxury-dark hover:bg-luxury-dark hover:text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                Call Now
              </a>
            </div>
          </RevealContent>
        </div>
      </section>
    </div>
  );
};

export default Gallery;